<div class="login-container">
    <div class="login-card">
        <!-- Logo y header -->
        <div class="login-header">
            <div class="logo-wrapper">
                <img src="assets/logos/logo.png" alt="Logo" class="logo" />
            </div>
            <h1 class="welcome-title">404</h1>
            <p class="welcome-subtitle">Página no encontrada</p>
        </div>

        <!-- Contenido del error -->
        <div class="error-content">
            <div class="error-icon">
                <i class="pi pi-exclamation-triangle"></i>
            </div>
            
            <p class="error-message">
                Lo sentimos, la página que estás buscando no existe o ha sido movida.
            </p>

            <!-- Opciones adicionales -->
            <div class="form-options">
                <a routerLink="/auth/login" class="option-link">
                    <i class="pi pi-home"></i>
                    Ir al inicio
                </a>
                <a  class="option-link" onclick="history.back()">
                    <i class="pi pi-arrow-left"></i>
                    Regresar
                </a>
                <a href="mailto:comunidad@avalanz.com" class="option-link">
                    <i class="pi pi-envelope"></i>
                    Contactar soporte
                </a>
            </div>
        </div>

        <!-- Footer -->
        <div class="form-footer">
            <p class="help-text">
                ¿Necesitas ayuda?
                <a href="mailto:comunidad@avalanz.com">Contacta soporte</a>
            </p>
        </div>
    </div>
</div>